import { CONTENT_LOCALES, FALLBACK_LOCALE, LOCALE_CONTENT_SOURCE, isTransliteratedLocale, } from '../constants/index.js';
import { latinToCyrillic } from './cyrillic.js';
/**
 * Tarjima qiymatidan bitta tildagi matnni oladi.
 * Tanlangan til bo'sh bo'lsa — `uz` ga fallback (CLAUDE.md §4).
 *
 * Kirillcha (`oz`) bazada SAQLANMAYDI: matn `uz` dan olinadi va shu
 * yerda o'giriladi (`utils/cyrillic.ts`). Butun sayt tarjimani shu
 * funksiya orqali o'qiydi, shuning uchun kirillcha o'z-o'zidan
 * hamma joyda ishlaydi — sahifalar, bloklar, menyu, mahsulotlar.
 */
export function resolveTranslation(value, locale) {
    if (!value)
        return '';
    const source = LOCALE_CONTENT_SOURCE[locale] ?? FALLBACK_LOCALE;
    const picked = value[source];
    const text = picked && picked.trim() !== '' ? picked : (value[FALLBACK_LOCALE] ?? '');
    return isTransliteratedLocale(locale) ? latinToCyrillic(text) : text;
}
/**
 * Qaysi tillar to'ldirilgan — admin panelda qizil nuqta ko'rsatish uchun.
 * Faqat BAZADAGI tillar bo'yicha: kirillcha to'ldirilmaydi.
 */
export function translationStatus(value) {
    const out = {};
    for (const l of CONTENT_LOCALES) {
        const v = value?.[l];
        out[l] = typeof v === 'string' && v.trim() !== '';
    }
    return out;
}
/** Kamida bitta tilda matn bormi. */
export function hasAnyTranslation(value) {
    return CONTENT_LOCALES.some((l) => (value?.[l] ?? '').trim() !== '');
}
const TRANSLATABLE_KEYS = new Set(CONTENT_LOCALES);
function isTranslatable(v) {
    if (typeof v !== 'object' || v === null || Array.isArray(v))
        return false;
    const keys = Object.keys(v);
    if (keys.length === 0 || keys.length > CONTENT_LOCALES.length)
        return false;
    return keys.every((k) => TRANSLATABLE_KEYS.has(k)) && keys.includes(FALLBACK_LOCALE);
}
/**
 * Obyekt ichidagi barcha `{uz,ru,en}` maydonlarni bitta tildagi matnga tekislaydi.
 * Public API `?lang=uz` bilan chaqirilganda ishlatiladi (docs/03-CONVENTIONS.md §6).
 *
 * Massivlar va ichma-ich obyektlar rekursiv aylanadi. `Date` va `ObjectId` kabi
 * maxsus obyektlar o'zgarishsiz qoladi.
 */
export function flattenTranslations(input, locale) {
    if (input === null || input === undefined)
        return input;
    if (Array.isArray(input))
        return input.map((i) => flattenTranslations(i, locale));
    if (typeof input !== 'object')
        return input;
    if (input instanceof Date)
        return input;
    if (isTranslatable(input))
        return resolveTranslation(input, locale);
    const out = {};
    for (const [k, v] of Object.entries(input)) {
        out[k] = flattenTranslations(v, locale);
    }
    return out;
}
/** Bo'sh tarjima qiymati. */
export function emptyTranslatable() {
    return { uz: '', ru: '', en: '' };
}
/** Bitta matndan uch tilli qiymat — seed va migratsiyada qulay. */
export function sameForAllLocales(text) {
    return { uz: text, ru: text, en: text };
}
//# sourceMappingURL=translation.js.map